<script>
    // import { currency_formatter } from "../globals.js";
    import {querystring} from 'svelte-spa-router'
    import { onDestroy, onMount } from 'svelte';
    // import JobTools from './jobtools.svelte';
    // import ResponsiveTable from '../utils/responsivetable3.svelte';
    import Header from "../header.svelte";
    // import Flatpickr from "../utils/Flatpickr.svelte";
    import {link, location, push, pop, replace} from 'svelte-spa-router';
    import IFTAInput from "../../utils/iftainput.svelte";


    let is_busy = false;
    let is_mounted = false;

    $: content_title = "Contents - Booking Page";

    onMount(async () => {
        setTimeout(()=>{is_mounted = true;}, 250);
    });

    let button_title = "Edit";
    let disabled = true;
    // let image_file;

    let book_now_copy = "By clicking Book Now, I acknowledge and agree Terms of Service.";

    let new_lead_email_to_the_prospect_subject = 'Thank you for contacting “Customer-company-name”';
    let new_lead_email_to_the_prospect_content = 'Hi “Customer\'s client\'s name”,\nThank you so much for contacting with us. Below are your inquiry details.\nAddress: “Customer’s client’s address”\nService: “Service type (weekly, biweekly...)”\nLawn:\nEntry instructions:\nTime preference:\nSpecial instruction message:\nService Price:\nFirst Service Date:\nNext Service Price:\nNext Service Date:\nWe’ll contact you promptly to follow up with you.\nAs always, our support team is always here to help. Feel free tocontact us should you require any assistance!\nSincerely,\n“Customer\'s first name” “Customer\'s business name”';

    
    let new_lead_email_to_the_customer_subject = "[Customer name] Look a new lead!";
    let new_lead_email_to_the_customer_content = "Hello\nThere's a new inquiry!\n• client name: Kelli Clemetson\n• address: 1640 East Flint Street, Chandler, AZ 85225\n• day of the service: 02-22-2020\n• price: $170.00\nClick here to see more details\nhttps://customer-name.com/users/sign_in\n*Upgrade to Prime Plan to sign up new clients with the online\nbooking features (appears basic, and plus plans customers only)";

    let new_booking_email_to_the_customer_subject = "[Customer name] Look a new service!";
    let new_booking_email_to_the_customer_content = "Hello\nThere's a new job!\n• client name: Kelli Clemetson\n• address: 1640 East Flint Street, Chandler, AZ 85225\n• day of the service: 02-22-2020\n• price: $170.00\nClick here to see more details\nhttps://customer-name.com/users/sign_in\n";

    let new_booking_email_to_the_client_subject = 'Thank you for booking with "Customer-company-name"';
    let new_booking_email_to_the_client_content = "Hi “Customer’s client’s name”,\nThank you so much for booking with us. Below are your service \nappointment details.\nAddress: “Customer’s client’s address”\nService: “Service type (weekly, biweekly...)”\nLawn:\nEntry instructions:\nTime preference:\nSpecial instruction message:\nService Price:\nFirst Service Date:\nNext Service Price:\nNext Service Date:\nAs our new client, we provided a free user account for you so that\nyou have full access to all your appointment details, viewchange \nprofile, and a lot more.\nClick here (link to customer’s home page/user/sign_in) to sign in\nAs always, our support team is always here to help. Feel free to\ncontact us should you require any assistance!\nSincerely,\n“Customer’s first name” “Customer’s business name”";
    
    let client_service_reminder_email_subject = "";
    let client_service_reminder_email_content = "";
    let client_service_reminder_email_options = ["1-day prior to the service date.", "2-days prior to the service date.", "3-days prior to the service date."];
    let client_service_reminder_email_value = "1-day prior to the service date.";

    function togglePublish() {
// console.log(image_file);
        if(!disabled) {
            // need to publish here
        }

        disabled = !disabled;

        if(!disabled) {
            button_title = "Publish";
        }else{
            button_title = "Edit";
        }
    }

	
</script>

<Header bind:title={content_title} bind:is_busy={is_busy} />
<div class="contentholder">

    <div class="section">

        <div class="sectionsubtitle">Contents under the Book Now and Contact Us buttons</div>
        <IFTAInput 
            label="Text Content"
            type="textarea"
            bind:value={book_now_copy}
            bind:disabled={disabled}
            helper_text="This text will appear under the book now and contact us buttons."
        />

        <div class="sectionsubtitle">New Lead Email to the prospect</div>
        <IFTAInput 
            label="Email Subject"
            type="text"
            bind:value={new_lead_email_to_the_prospect_subject}
            bind:disabled={disabled}
            helper_text="This text will appear in the subject line of the email."
        />
        <IFTAInput 
            label="Email Content"
            type="textarea"
            bind:value={new_lead_email_to_the_prospect_content}
            bind:disabled={disabled}
            helper_text="This text will appear as the content of the email."
        />

        <div class="sectionsubtitle">New lead email to the customer</div>
        <IFTAInput 
            label="Email Subject"
            type="text"
            bind:value={new_lead_email_to_the_customer_subject}
            bind:disabled={disabled}
            helper_text="This text will appear in the subject line of the email."
        />
        <IFTAInput 
            label="Email Content"
            type="textarea"
            bind:value={new_lead_email_to_the_customer_content}
            bind:disabled={disabled}
            helper_text="This text will appear as the content of the email."
        />

        <div class="sectionsubtitle">New Booking email to the customer</div>
        <IFTAInput 
            label="Email Subject"
            type="text"
            bind:value={new_booking_email_to_the_customer_subject}
            bind:disabled={disabled}
            helper_text="This text will appear in the subject line of the email."
        />
        <IFTAInput 
            label="Email Content"
            type="textarea"
            bind:value={new_booking_email_to_the_customer_content}
            bind:disabled={disabled}
            helper_text="This text will appear as the content of the email."
        />

        <div class="sectionsubtitle">New Booking Email to the client</div>
        <IFTAInput 
            label="Email Subject"
            type="text"
            bind:value={new_booking_email_to_the_client_subject}
            bind:disabled={disabled}
            helper_text="This text will appear in the subject line of the email."
        />
        <IFTAInput 
            label="Email Content"
            type="textarea"
            bind:value={new_booking_email_to_the_client_content}
            bind:disabled={disabled}
            helper_text="This text will appear as the content of the email."
        />

        <div class="sectionsubtitle">Client Service Reminder Email</div>
        <IFTAInput 
            label="Email Subject"
            type="text"
            bind:value={client_service_reminder_email_subject}
            bind:disabled={disabled}
            helper_text="This text will appear in the subject line of the email."
        />
        <IFTAInput 
            label="Email Content"
            type="textarea"
            bind:value={client_service_reminder_email_content}
            bind:disabled={disabled}
            helper_text="This text will appear as the content of the email."
        />
        <IFTAInput 
            label="Email Content"
            type="select"
            bind:value={client_service_reminder_email_value}
            bind:disabled={disabled}
            bind:select_options={client_service_reminder_email_options}
            helper_text="When to send reminder email to client."
        />

        

    
    </div>


    <div class="buttonholder">
        <button on:click={()=>{togglePublish();}}>{button_title}</button>
    </div>

</div>

<style>
    .ff {
        padding: 10px;
        width: 100%;
    }
    :global(.ff .group) {
        margin-left: 5px;
        margin-right: 5px;
    }

    .formrow {
        padding: 0px;
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }

    .section_old {
        margin-top: 25px;
        width: 100%;
    }

    .section_old .sectiontitle_old {
        width: 100%;
        font-size: 20px;
        color: white;
        background-color: #1769aa;
        margin-bottom: 10px;
    }
    .section_old .sectiontitle_old i{
        width: 25px;
        display: none;

    }
    .section_old .sectionsubtitle_old {
        width: 100%;
        margin-top: 10px;
        margin-bottom: 10px;
        font-weight: bold;
        font-size: 16px;
        color: white;
        background-color: #1769aa;
        color: white;
        padding: 5px;
        box-sizing: border-box;
    }
    .sectioninfo {
        width: 100%;
        display: flex;
        flex-direction: column;
    }

    .column{
        padding: 0px;
        margin: 0px;
        display: flex;
        flex-direction: column;
        width: 100%;
    }
    .row{
        padding: 0px;
        margin: 0px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 100%;
    }
    :global(.rowwrap) {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
    }

    :global(.rowwrap .group) {
        min-width: 200px;
        max-width: 200px;
    }

    :global(.rowwrap .group) {
        min-width: 200px;
        max-width: 200px;
    }
    .contentholder {
        padding: 0px;
    }

    .buttonholder {
        margin-top: 10px;
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }
    .buttonholder button {
        max-width: 300px;
        /* width: 100%; */
        background-color: #357a38;
        color: white;
    }
    :global(.flatpickr-input) {
        /* background-color: #ff9100; */
        /* color: white; */
        width: 250px;
    }
    .toolsholder {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        box-sizing: border-box;
    }

    :global(.toolsholder .group) {
        padding-left: 10px;
        padding-right: 10px;
    }
    .highlight {
        border: 1px solid black;
        padding: 10px;
        box-sizing: border-box;
    }
    .newitembuttonholder {
        margin-left: 10px;
        width: 40%;
        display: flex;
        flex-direction: row;
        justify-content: start;
        align-items: center;
    }

    .newitembuttonholder button{
        max-width: 100px;
        width: 100px;
        height: 40px;
    }

    .newitembuttonholder button.savebutton{
        color: #1c54b2;
        background-color: white;
     }

    .newitembuttonholder button.cancelbutton{
        color: #b2102f;
        background-color: white;
    }

    @media (max-device-width: 1024px), (max-width: 1023px) {
        .ff {
            padding: 0px;
            width: 100%;
        }
        .formrow {
            width: 100%;
            padding: 0px;
            display: flex;
            flex-direction: column;
        }

        .section_old {
            padding: 0px;
        }
        .sectioninfo {
            width: 100%;
            display: flex;
            flex-direction: column;
            padding: 0px;
            margin: 0px;
        }
        .column{
            padding: 0px;
            margin: 0px;
            display: flex;
            flex-direction: column;
            width: 100%;
        }
        .row{
            padding: 0px;
            margin: 0px;
            display: flex;
            flex-direction: column;
            width: 100%;
        }
        :global(.rowwrap) {
            width: 100%;
            display: flex;
            flex-direction: column;
            padding: 0px;
            margin: 0px;
        }

        :global(.rowwrap .group) {
            width: 100%;
            min-width: 100%;
            max-width: 100%;
        }
        .contentholder {
            padding: 0px;
            width: 100%;
            max-width: 100vw;
            margin-left: auto;
            margin-right: auto;
        }
        .buttonholder {
            /* max-width: 100%; */
            width: 100%;
            display: flex;
            flex-direction: column;
        }
        .buttonholder button{
            max-width: 100%;
            width: 100%;
        }
        :global(.flatpickr-input) {
            /* background-color: #ff9100; */
            /* color: white; */
            width: 100%;
        }
        .toolsholder {
            width: 100%;
            display: flex;
            flex-direction: column;
        }
        :global(.toolsholder .group) {
            padding-left: 0px;
            padding-right: 0px;
        }

        .newitembuttonholder {
            margin-left: 0px;
            margin-top: 10px;
            width: 100%;
            display: flex;
            flex-direction: column;
        }

        .newitembuttonholder button{
            max-width: 100%;
            width: 100%;
            height: 40px;
        }

        :global(.rowwrap .group) {
            min-width: 100%;
            max-width: 100%;
        }

    }

</style>